import { Children, forwardRef, HtmlHTMLAttributes, memo, useState } from "react";
import classNames from "classnames";
import { SortableItemProps } from "../types";

import { ReactComponent as DragIcon } from "./icons/drag.svg";

import styles from "./style.module.scss";

export type SortableItemContainerProps = HtmlHTMLAttributes<HTMLDivElement> & SortableItemProps & {
  dragButtonPosition?: "start" | "end";
  dragButtonProps?: HtmlHTMLAttributes<HTMLDivElement>;
}

export const SortableItemContainer = memo<SortableItemContainerProps>(forwardRef<HTMLDivElement, SortableItemContainerProps>(((
  {
    isDragging,
    disabled,
    dragHandleProps,
    draggableProps,
    dragButtonPosition = "end",
    dragButtonProps,
    ...props
  }, ref) => {

  const [ hovered, setHovered ] = useState(false);

  const dragButton =
    <div
      key="dragButton"
      {...dragButtonProps}
      {...dragHandleProps}
      onPointerDown={() => setHovered(true)}
      onPointerUp={() => setHovered(false)}
      onPointerEnter={() => setHovered(true)}
      onPointerOut={() => setHovered(false)}
      className={classNames(dragButtonProps?.className, styles.dragButton)}
    >
      <DragIcon key="DragIcon" width={20} height={20} />
      {dragButtonProps?.children}
    </div>;

  return (
    <div
      ref={ref}
      {...draggableProps}
      {...props}
      className={classNames(
        styles.root,
        props.className,
        {
          [styles.disabled]: disabled,
          [styles.dragging]: isDragging,
          [styles.hovered]: hovered,
          [styles.dragButtonStart]: dragButtonPosition === "start",
          [styles.dragButtonEnd]: dragButtonPosition === "end",
        },
      )
      }
    >
      {dragButtonPosition === "start" && dragButton}
      {Children.map(props.children, child =>
        typeof child === "string" ? <span key={child}>{child}</span> : child,
      )}
      {dragButtonPosition === "end" && dragButton}
    </div>
  );
})));
